function shouldShowWeeklyRecapBanner(recap) {
  return Boolean(recap?.status === "ready" && !recap?.banner?.dismissedAt);
}

function getWeeklyRecapShareText(recap) {
  return typeof recap?.share?.text === "string" ? recap.share.text : "";
}

export { getWeeklyRecapShareText, shouldShowWeeklyRecapBanner };
